import { RECIPE_FACETS } from '../../constants/recipeFacets';

interface FacetValueCountPair {
  value: string;
  count: number;
}

interface RecipeFacetResult {
  facet: string;
  pairs?: Array<FacetValueCountPair> | null;
}

interface FilterOption {
  title: string;
  filter: string;
  count: number;
}

interface FilterGroup {
  title: string;
  filterType: string;
  options: Array<FilterOption>;
}

/**
 * Maps Algolia recipe facets into the filter group shape the RecipeCategory filter UI expects.
 *
 * @param facets - The facets array from the search response, each with a facet key and value/count pairs.
 * @param titles - A map of facet key to its display title.
 * @returns Filter groups in fixed display order, each with options sorted alphabetically by value; facets with no matches are omitted.
 */
export const mapFacetsToFilters = (
  facets: Array<RecipeFacetResult> | null | undefined,
  titles: Record<string, string>,
): Array<FilterGroup> => {
  const byFacet: Record<string, RecipeFacetResult> = Object.fromEntries(
    (facets ?? []).map((f): [string, RecipeFacetResult] => [f.facet, f]),
  );

  return RECIPE_FACETS.filter((key) => byFacet[key]?.pairs?.length).map((key) => ({
    title: titles[key],
    filterType: key,
    options: [...(byFacet[key]?.pairs ?? [])]
      .sort((a, b) => a.value.localeCompare(b.value))
      .map((pair) => ({ title: pair.value, filter: pair.value, count: pair.count })),
  }));
};
